module.exports = __webpack_public_path__ + "static/media/followers.55975fa2.svg";